import React from 'react'
import MOCK_DATA from './MOCK_DATA.json'

interface VariantTable2Props {
	showDeliveryVariant: boolean
}

interface Variant {
	value: string
	price: string
	sku: string
	stockQuantity: number
}

interface InnerVariantValue {
	price: string
	sku: string
	stockQuantity: number
	dimension: {
		width: number
		length: number
		height: number
	}
	weight: number
}

interface InnerVariant {
	name: string
	values: InnerVariantValue[]
}

interface MockData {
	name: string
	items: Variant[]
	innerVariants: {
		name: string
		items: InnerVariant[]
	}
}

const data: MockData = MOCK_DATA as MockData

const VariantTable2: React.FC<VariantTable2Props> = ({ showDeliveryVariant }) => {
	return (
		<div className="mb-10">
			<table className="table table-bordered table-striped">
				<thead className="thead-dark">
					<tr>
						<th style={{ width: '10%' }}>{data.name}</th>
						<th style={{ width: '10%' }}>{data.innerVariants.name}</th>
						<th style={{ width: '20%' }}>Price</th>
						{showDeliveryVariant && (
							<>
								<th style={{ width: '20%' }}>Dimension</th>
								<th style={{ width: '20%' }}>Weight</th>
							</>
						)}
						<th style={{ width: '20%' }}>Stock Quantity</th>
						<th style={{ width: '20%' }}>SKU</th>
					</tr>
				</thead>
				<tbody>
					{data.items.map((variant, index) =>
						data.innerVariants.items.map((innerVariant, innerIndex) => (
							<tr key={`${variant.value}-${innerVariant.name}`}>
								{innerIndex === 0 ? (
									<td rowSpan={data.innerVariants.items.length} className="text-center">
										{variant.value}
									</td>
								) : null}
								<td>{innerVariant.name}</td>
								<td>
									<input
										type="text"
										className="form-control"
										name={`${variant.value}_${innerVariant.name}_price`}
										defaultValue={innerVariant.values[index]?.price}
										placeholder="Price"
									/>
								</td>
								{showDeliveryVariant ? (
									<>
										<td>
											<input
												type="text"
												className="form-control"
												name={`${variant.value}_${innerVariant.name}_dimension`}
												defaultValue={innerVariant.values[index]?.dimension.height.toString()}
												placeholder="Dimension"
											/>
										</td>
										<td>
											<input
												type="text"
												className="form-control"
												name={`${variant.value}_${innerVariant.name}_weight`}
												defaultValue={innerVariant.values[index]?.weight.toString()}
												placeholder="Weight"
											/>
										</td>
									</>
								) : null}
								<td>
									<input
										type="text"
										className="form-control"
										name={`${variant.value}_${innerVariant.name}_stockQuantity`}
										defaultValue={innerVariant.values[index]?.stockQuantity.toString()}
										placeholder="Stock Quantity"
									/>
								</td>
								<td>
									<input
										type="text"
										className="form-control"
										name={`${variant.value}_${innerVariant.name}_sku`}
										defaultValue={innerVariant.values[index]?.sku}
										placeholder="SKU"
									/>
								</td>
							</tr>
						))
					)}
				</tbody>
			</table>
		</div>
	)
}

export default VariantTable2
